<template>
  <div class="actions">
    <button
      @click="openEditModal()"
      id="editButton"
      type="button"
      rel="tooltip"
      class="btn btn-success btn-sm btn-icon"
    >
      <i class="tim-icons icon-settings"></i>
    </button>
    <button
      @click="openDeleteModal()"
      id="deleteButton"
      type="button"
      rel="tooltip"
      class="btn btn-danger btn-sm btn-icon ml-1"
    >
      <i class="tim-icons icon-simple-remove"></i>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    itemId: {
      type: Number
    },
    itemType: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    openDeleteModal() {
      let params = {};
      params[this.itemType] = this.itemId;
      params.state = true;
      this.$emit("openDeleteModal", params);
    },
    openEditModal() {
      let params = {};
      params[this.itemType] = this.itemId;
      params.state = true;
      this.$emit("openEditModal", params);
    }
  }
};
</script>
<style scoped lang="scss"></style>
